import { useCallback } from 'react';

export type ApplyFormSubmitError = 'generic' | 'deactivatedJob' | 'noXingApply';

const submitErrorCopyKeys: Record<ApplyFormSubmitError, string> = {
  generic: 'JOBS_INSTANT_APPLY_FORM_SUBMIT_GENERIC_ERROR',
  deactivatedJob: 'JOBS_INSTANT_APPLY_FORM_SUBMIT_DEACTIVATED_ERROR',
  noXingApply: 'JOBS_INSTANT_APPLY_FORM_SUBMIT_TYPE_ERROR',
};

const submitErrorNWTContexts: Record<ApplyFormSubmitError, string> = {
  generic: 'instant_apply_submit_error_network_issue',
  deactivatedJob: 'instant_apply_submit_error_deactivated_job',
  noXingApply: 'instant_apply_submit_error_no_xing_application',
};

export type NwtSubmitErrorTrackingProps = {
  eventSchema: 'basic';
  context: string;
  event: string;
  page: string;
};

type ApplyFormSubmitErrorsValue = {
  showSubmitError: (error: ApplyFormSubmitError) => void;
};

export const useApplyFormSubmitErrors = (
  trackNwt: (eventProps: NwtSubmitErrorTrackingProps) => void,
  showErrorBanner: (copyId: string) => void
): ApplyFormSubmitErrorsValue => {
  const showSubmitError = useCallback(
    (error: ApplyFormSubmitError) => {
      if (submitErrorCopyKeys[error]) {
        showErrorBanner(submitErrorCopyKeys[error]);
      }
      if (submitErrorNWTContexts[error]) {
        trackNwt({
          eventSchema: 'basic',
          context: submitErrorNWTContexts[error],
          event: 'error_shown',
          page: 'jobs/apply',
        });
      }
    },
    [showErrorBanner, trackNwt]
  );

  return {
    showSubmitError,
  };
};
